import { ScopeStatsView, VariableStatsView } from '../../../lib/PlannerDTOs';
import { State } from '../../../store/state';
import { getArraysIntersection } from '../../../utils/string';
import { variableStatsEntitiesSelector } from '../entities/selectors';

export const variableStatsSelector = (
  state: State,
  variableName: string,
): VariableStatsView => {
  const variableStatsEntities = variableStatsEntitiesSelector(state);
  let variableStats = variableStatsEntities
    ? variableStatsEntities[variableName]
    : state.variableStats!.latestVariableStats;
  variableStats = variableStats
    ? variableStats
    : state.variableStats!.latestVariableStats;
  return variableStats;
};

// variableScopeCommonFacetsSelector selects the intersection of facets in all the scopes for this variable
export const variableScopeCommonFacetsSelector = (
  state: State,
  variableName: string,
): string[] => {
  const stats = variableStatsSelector(state, variableName);
  const facetLists: string[][] = [];
  const scopes = new Map(Object.entries(stats.scopes!));

  // transform facets by scope to facetLists
  scopes.forEach((value: ScopeStatsView, _key: string) => {
    const facets = new Map(Object.entries(value.facets));
    facetLists.push(Array.from(facets.keys()));
  });

  // get intersection from facetLists
  const result = getArraysIntersection(facetLists);

  // add Time(ts) which is an available facets by default, and it won't show in the variable stats
  // and time should not be the only facet sent from user's service
  if (result.length > 0) {
    result.push('ts');
  }

  return result;
};

export const variableStatsViewSelector = (state: State) => {
  return state.variableStats!.view;
};
